import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  LinearProgress,
  CircularProgress,
  Alert,
} from '@mui/material';
import { CloudDownload as DownloadIcon } from '@mui/icons-material';

/**
 * Dialog showing download progress for bulk file operations.
 * @param {{ progress: object, onClose: function }} props
 */
const DownloadProgressDialog = ({ progress, onClose }) => {
  const { status, current, total, filename, error } = progress;

  return (
    <Dialog open={status !== 'idle'} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <DownloadIcon sx={{ mr: 1 }} />
          Downloading Files
        </Box>
      </DialogTitle>
      <DialogContent>
        {status === 'fetching' && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 2 }}>
            <CircularProgress size={24} />
            <Typography>Preparing download...</Typography>
          </Box>
        )}
        {status === 'downloading' && (
          <Box sx={{ py: 2 }}>
            <Typography gutterBottom>
              Downloading {current} of {total}...
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom noWrap>
              {filename}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={total > 0 ? (current / total) * 100 : 0}
              sx={{ mt: 2, height: 8, borderRadius: 4 }}
            />
          </Box>
        )}
        {status === 'complete' && (
          <Box sx={{ py: 2 }}>
            <Alert severity="success">
              Download complete! {total} files saved.
            </Alert>
          </Box>
        )}
        {status === 'error' && (
          <Box sx={{ py: 2 }}>
            <Alert severity="error">
              Error: {error}
            </Alert>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={status === 'fetching' || status === 'downloading'}
        >
          {status === 'complete' || status === 'error' ? 'Close' : 'Cancel'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadProgressDialog;
